import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=0ba0167c&"
import script from "./Publications.vue?vue&type=script&lang=js&"
export * from "./Publications.vue?vue&type=script&lang=js&"
import style0 from "./Publications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports